import script from "./header1.vue?vue&type=script&setup=true&name=header1&lang=js"
export * from "./header1.vue?vue&type=script&setup=true&name=header1&lang=js"

import "./header1.vue?vue&type=style&index=0&id=1ddd6b62&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ddd6b62"]])

export default __exports__